import DjangoMessages from 'components/DjangoMessages';
import Checkboxes from 'components/Form/Checkboxes';
import FormActions from 'components/Form/FormActions';
import SubmitButton from 'components/Form/SubmitButton';
import HorizontalRule from 'components/Layout/HorizontalRule';
import SideBySide from 'components/Layout/SideBySide';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {c, t} from 'ttag';
import {documentTypeCheckboxOptions} from 'utils/document-type';
import {setUrl} from 'utils/request';

import {useModifyApprovalSettings} from '../services';
import {BackendData, EditFormData} from '../types';
import {approvalSettingsCheckboxOptions} from '../utils';

const useInitialValue = (): EditFormData => {
    const {data} = useBackend<BackendData>();
    const [result] = useState<EditFormData>(() => {
        return {
            acceptance: data.approvalSettings.acceptance || false,
            deliveryslip: data.approvalSettings.deliveryslip || false,
            direct_approval_disabled:
                data.approvalSettings.directApprovalDisabled || false,
            editing_on_approval_request_disabled:
                data.approvalSettings.editingOnApprovalRequestDisabled || false,
            invoice: data.approvalSettings.invoice || false,
            is_editing_on_approval_disabled:
                data.approvalSettings.isEditingOnApprovalDisabled || false,
            order: data.approvalSettings.order || false,
            orderconfirmation: data.approvalSettings.orderconfirmation || false,
            orderslip: data.approvalSettings.orderslip || false,
            paymentnotice: data.approvalSettings.paymentnotice || false,
            quote: data.approvalSettings.quote || false,
            receipt: data.approvalSettings.receipt || false,
            self_approval_disabled:
                data.approvalSettings.selfApprovalDisabled || false,
            timesheet: data.approvalSettings.timesheet || false,
        };
    });
    return result;
};

const Page = () => {
    const initialData = useInitialValue();
    const methods = useForm<EditFormData>({
        defaultValues: initialData,
        shouldUnregister: true,
    });
    const apiEdit = useModifyApprovalSettings();

    const handleSubmit = async (data: EditFormData) => {
        await apiEdit.mutateAsync(data).then(() => {
            setUrl(window.Urls.approval_settings_view());
        });
    };

    const submitDisabled =
        methods.formState.isSubmitting || !methods.formState.isDirty;

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(handleSubmit)}>
                <DjangoMessages className="mb-4" />
                <NavigationTabs.DocumentSettings selection="documentApproval" />

                <SectionHeader
                    subtitle={c('approval-settings')
                        .t`You can enable approval-related checks on a per-document-type basis`}
                    title={c('approval-settings').t`Approval Settings`}
                />
                <SideBySide className="mt-4">
                    <Checkboxes
                        label={t`Document Type`}
                        options={documentTypeCheckboxOptions()}
                    />
                    <HorizontalRule />
                    <Checkboxes
                        label={c('approval-settings').t`Approval Settings`}
                        options={approvalSettingsCheckboxOptions()}
                    />
                    <FormActions align="left">
                        <SubmitButton
                            disabled={submitDisabled}
                        >{t`Save`}</SubmitButton>
                    </FormActions>
                </SideBySide>
            </form>
        </FormProvider>
    );
};
export default Page;
